import { axios } from '@/utils/request'
// 查询客户下单数量
export function getCount(parameter) {
  return axios({
    url: '/order/customer/getCustomerOrderCount',
    method: 'get',
    params: parameter
  })
}
// 查询企业列表哦  null
export function getEnterprise(parameter) {
  return axios({
    url: '/enterprise/management/selectCombox',
    method: 'get',
    params: parameter
  })
}
// 查询订单类型    智能锁  'SMART_SWITCH'
export function getOrderType(parameter) {
  return axios({
    url: `/basicdata/orderType/getList/${parameter}`,
    method: 'get'
  })
}
// 获取订单负责人  null
export function getOrderPrincipal(parameter) {
  return axios({
    url: 'system/user/findByDeptId/103',
    method: 'get',
    params: parameter
  })
}
